// extracted by mini-css-extract-plugin
export default {"container":"Result_container__59S6s","zeroResultContainer":"Result_zeroResultContainer__Llg5L","zeroResultText":"Result_zeroResultText__F-+1q"};